import { Typography } from '@mantine/core';
import DOMPurify from 'dompurify';

type Props = {
  html?: string | null;
  allowTargetBlank?: boolean;
};

const DisplayHtml = ({ html, allowTargetBlank = false }: Props) => {
  if (!html || html.trim().length === 0) {
    return null;
  }
  const cleanHtml = DOMPurify.sanitize(html, {
    ADD_ATTR: allowTargetBlank ? ['target', 'rel'] : [],
  });

  return (
    <Typography>
      <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />
    </Typography>
  );
};

export default DisplayHtml;
